export enum ApiRoutesOffers {
  SpecialOffers = "admin/special-offers",
  SectionStyle = "section-style",
  OffersReorder = "reorder"
}

export enum OffersStatus {
  Active = "Active",
  Inactive = "Inactive"
}
